export const graphBaseStyles = [
  {
    selector: "node",
    style: {
      width: '88px',
      height: '88px',
      label: "data(label)",
      "background-color": "#4A90E2",
      "background-opacity": 0.9,
      shape: 'ellipse',
      "text-valign": "center",
      "text-halign": "center",
      "text-wrap": "wrap",
      "text-max-width": "80px",
      color: "#FFFFFF",
      "font-size": "16px",
      "font-weight": "bold",
      "text-outline-color": "#1A1A1A",
      "text-outline-width": "2px",
      "overlay-padding": "8px",
      "z-index": "10",
      "border-width": "2px",
      "border-color": "#2E5F8F",
      "border-opacity": 1,
      "transition-property": "background-color, border-width, border-color",
      "transition-duration": "0.2s"
    }
  },
  {
    selector: "node:selected",
    style: {
      "border-width": "4px",
      "border-color": "#FF9800",
      "background-color": "#FF5722",
      "box-shadow": "0px 0px 20px rgba(255, 152, 0, 0.8)"
    }
  },
  {
    selector: "node:hover",
    style: {
      "border-width": "3px",
      "border-color": "#FFC107",
      "background-color": "#5FA3E8"
    }
  },
  {
    selector: "node[type='central']",
    style: {
      width: '116px',
      height: '116px',
      "background-color": "#E74C3C",
      "border-color": "#C0392B",
      "border-width": "3px"
    }
  },
  {
    selector: "edge",
    style: {
      width: 2,
      "line-color": "#90CAF9",
      "line-opacity": 0.7,
      "target-arrow-color": "#64B5F6",
      "target-arrow-shape": "triangle",
      "curve-style": "bezier",
      "arrow-scale": 1.5,
      label: "data(label)",
      "font-size": "10px",
      "text-rotation": "autorotate",
      "text-margin-y": -10,
      "text-background-color": "#FFFFFF",
      "text-background-opacity": 0.8,
      "text-background-padding": "3px",
      "text-border-opacity": 0.5,
      "text-border-width": 1,
      "text-border-color": "#CCCCCC",
      color: "#333333"
    }
  },
  {
    selector: "edge[source][hop >= 3], edge[target][hop >= 3]",
    style: {
      width: 1,
      "line-opacity": 0.4,
      "arrow-scale": 1,
      "font-size": "8px"
    }
  },
  {
    selector: "edge.edge-out",
    style: {
      "line-color": "#E53935",
      "target-arrow-color": "#E53935",
      "line-opacity": 0.95,
      "arrow-scale": 1.7
    }
  },
  {
    selector: "edge.edge-in",
    style: {
      "line-color": "#43A047",
      "target-arrow-color": "#43A047",
      "line-opacity": 0.95,
      "arrow-scale": 1.7
    }
  },
  {
    selector: "edge.edge-out:selected, edge.edge-out:hover",
    style: {
      "line-color": "#E53935",
      "target-arrow-color": "#E53935",
      "line-opacity": 1,
      "arrow-scale": 2
    }
  },
  {
    selector: "edge.edge-in:selected, edge.edge-in:hover",
    style: {
      "line-color": "#43A047",
      "target-arrow-color": "#43A047",
      "line-opacity": 1,
      "arrow-scale": 2
    }
  },
];
